export default __webpack_public_path__ + "static/media/pay-icon.d4e72e3b.webp";